import './resources.css'

const ThirdWebinarResource = () => {
    return (
        <ul className= 'additional-resources' >
            <h3> Additional Resources: </h3>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/Assets/step1-movement-risks-biosecurity.pdf")}> Movement Risks and Biosecurity Checklist (CFSPH)  </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/diseaseinfo/")}> Animal Diseases (CFSPH) </li>
            <li onClick={() => window.open("https://www.avma.org/resources/public-health/disease-precautions-hunters")}> Disease Precautions for Hunters (AVMA) </li>
            {/*Nested List */}
            <li onClick={()=> window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-agritourism.pdf")}> Agritourism Biosecurity Tip Sheet (CFSPH) </li>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-personnel.pdf")}> Personnel Biosecurity Tip Sheet (CFSPH)  </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-wildlife-rodent.pdf")}> Wildlife, Rodent & Other Animal Control Biosecurity Tip Sheet (CFSPH)</li>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/Infection_Control/Routes/English/general_bird_rodent_control.pdf")}> Bird & Rodent Control Measures (CFSPH)  </li>
            <li onClick={() => window.open("https://www.healthyagriculture.org/livestock/wildlife-feral-animals/")}> Wildlife and Feral Animals (HFHA)</li>
        </ul>
    )
}

export default ThirdWebinarResource;